/**
 * KOSTCH homepage interactions — carousels, scene shop, media sliders
 */
(function () {
  function initProductCarousel(root) {
    var track = root.querySelector('[data-kostch-carousel-track]');
    if (!track || !track.children.length) return;

    var strip = root.querySelector('.kostch-products__strip');
    var prev = root.querySelector('[data-kostch-carousel-prev]');
    var next = root.querySelector('[data-kostch-carousel-next]');
    var index = 0;

    function visibleCount() {
      if (window.innerWidth <= 640) return 1;
      if (window.innerWidth <= 1100) return 2;
      return 4;
    }

    function maxIndex() {
      return Math.max(0, track.children.length - visibleCount());
    }

    function stepSize() {
      var first = track.children[0];
      if (!first) return 0;
      var gap = parseFloat(getComputedStyle(track).gap) || 24;
      return first.offsetWidth + gap;
    }

    function update() {
      var max = maxIndex();
      if (max === 0) {
        index = 0;
      } else {
        index = ((index % (max + 1)) + (max + 1)) % (max + 1);
      }
      track.style.transform = 'translateX(-' + index * stepSize() + 'px)';
      if (prev) prev.disabled = false;
      if (next) next.disabled = false;
      if (strip) strip.classList.toggle('is-scrollable', max > 0);
    }

    if (prev) {
      prev.addEventListener('click', function () {
        var max = maxIndex();
        if (max === 0) return;
        index = index <= 0 ? max : index - 1;
        update();
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        var max = maxIndex();
        if (max === 0) return;
        index = index >= max ? 0 : index + 1;
        update();
      });
    }

    window.addEventListener('resize', update);
    update();
  }

  function initMediaCarousel(root) {
    var slides = root.querySelectorAll('[data-kostch-media-slide]');
    if (slides.length <= 1) return;

    var section = root.closest('[data-kostch-media-section]') || root;
    var track = root.querySelector('[data-kostch-media-track]') || root;
    var dots = section.querySelectorAll('[data-kostch-media-dot]');
    var prev = section.querySelector('[data-kostch-media-prev]');
    var next = section.querySelector('[data-kostch-media-next]');
    var current = 0;
    var timer = null;
    var autoplay = section.hasAttribute('data-kostch-media-autoplay');
    var speed = parseInt(section.getAttribute('data-kostch-media-autoplay-speed'), 10) || 4000;

    function show(idx) {
      current = (idx + slides.length) % slides.length;
      track.style.transform = 'translate3d(-' + current * 100 + '%, 0, 0)';
      slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === current);
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === current);
      });
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function startAutoplay() {
      if (!autoplay || slides.length <= 1) return;
      stopAutoplay();
      timer = setInterval(function () {
        show(current + 1);
      }, speed);
    }

    function go(idx) {
      show(idx);
      startAutoplay();
    }

    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        go(parseInt(dot.getAttribute('data-kostch-media-dot'), 10));
      });
    });

    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);
    section.addEventListener('focusin', stopAutoplay);
    section.addEventListener('focusout', function (e) {
      if (!section.contains(e.relatedTarget)) startAutoplay();
    });

    show(0);
    startAutoplay();
  }

  function initSceneShop(root) {
    var scenes = root.querySelectorAll('[data-scene-panel]');
    var dots = root.querySelectorAll('[data-scene-dot]');
    if (!scenes.length) return;

    var current = 0;
    var ignoreEditorSelect = false;

    function activeHotspot(scene) {
      return scene.querySelector('[data-scene-hotspot].is-active') ||
        scene.querySelector('[data-scene-hotspot]');
    }

    function showScene(index) {
      var nextIdx = (index + scenes.length) % scenes.length;
      if (nextIdx === current) return;
      current = nextIdx;

      scenes.forEach(function (scene, i) {
        scene.classList.toggle('is-active', i === current);
        scene.classList.remove('is-leaving', 'is-entering');
        scene.querySelectorAll('.kostch-scene-shop__image, [data-scene-detail]').forEach(function (el) {
          el.getAnimations().forEach(function (animation) { animation.cancel(); });
        });
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === current);
      });

      var hotspot = activeHotspot(scenes[current]);
      if (hotspot) selectHotspot(hotspot, scenes[current]);
    }

    function selectHotspot(btn, scene) {
      scene.querySelectorAll('[data-scene-hotspot]').forEach(function (h) {
        h.classList.remove('is-active');
        h.setAttribute('aria-current', 'false');
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-current', 'true');

      var idx = btn.getAttribute('data-product-index');
      scene.querySelectorAll('[data-scene-product-chip]').forEach(function (c) {
        c.classList.toggle('is-active', c.getAttribute('data-product-index') === idx);
      });

      var detail = scene.querySelector('[data-scene-detail]');
      if (!detail) return;

      var imgUrl = btn.getAttribute('data-product-image');
      var imgWrap = detail.querySelector('[data-scene-detail-image]');
      if (imgWrap) {
        imgWrap.innerHTML = imgUrl
          ? '<img src="' + imgUrl + '" alt="">'
          : '';
      }

      var titleEl = detail.querySelector('[data-scene-detail-title]');
      var priceEl = detail.querySelector('[data-scene-detail-price]');
      var linkEl = detail.querySelector('[data-scene-detail-link]');
      var variantInput = detail.querySelector('[data-scene-detail-variant]');
      var formEl = detail.querySelector('[data-scene-detail-form]');
      var skuEl = detail.querySelector('[data-scene-detail-sku]');

      if (titleEl) titleEl.textContent = btn.getAttribute('data-product-title') || '';
      if (skuEl) skuEl.textContent = btn.getAttribute('data-product-sku') || '';
      if (priceEl) priceEl.textContent = btn.getAttribute('data-product-price') || '';
      if (linkEl) {
        var url = btn.getAttribute('data-product-url') || '';
        if (!url || url === '#') url = '/collections/all';
        linkEl.href = url;
      }
      if (variantInput) variantInput.value = btn.getAttribute('data-variant-id') || '';
      if (formEl) formEl.style.display = variantInput && variantInput.value ? '' : 'none';
      detail.classList.remove('is-updating');
    }

    if (scenes.length <= 1) {
      root.querySelectorAll('[data-scene-prev], [data-scene-next]').forEach(function (btn) {
        btn.hidden = true;
      });
      var dotsWrap = root.querySelector('[data-scene-dots]');
      if (dotsWrap) dotsWrap.hidden = true;
    }

    root.querySelectorAll('[data-scene-prev]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        ignoreEditorSelect = true;
        showScene(current - 1);
        window.setTimeout(function () { ignoreEditorSelect = false; }, 400);
      });
    });
    root.querySelectorAll('[data-scene-next]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        ignoreEditorSelect = true;
        showScene(current + 1);
        window.setTimeout(function () { ignoreEditorSelect = false; }, 400);
      });
    });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        showScene(parseInt(dot.getAttribute('data-scene-dot'), 10));
      });
    });
    root.querySelectorAll('[data-scene-hotspot]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        selectHotspot(btn, btn.closest('[data-scene-panel]'));
      });
    });
    root.querySelectorAll('[data-scene-product-chip]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var scene = chip.closest('[data-scene-panel]');
        var idx = chip.getAttribute('data-product-index');
        var hotspot = scene.querySelector('[data-scene-hotspot][data-product-index="' + idx + '"]');
        if (hotspot) selectHotspot(hotspot, scene);
      });
    });

    scenes.forEach(function (scene, i) {
      scene.classList.toggle('is-active', i === 0);
      var hotspot = activeHotspot(scene);
      if (hotspot) selectHotspot(hotspot, scene);
    });
    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === 0);
    });

    document.addEventListener('shopify:block:select', function (event) {
      if (ignoreEditorSelect) return;
      var panel = event.target && event.target.closest ? event.target.closest('[data-scene-panel]') : null;
      if (!panel || !root.contains(panel)) return;
      var idx = parseInt(panel.getAttribute('data-scene-index'), 10);
      if (!isNaN(idx)) showScene(idx);
    });
  }

  function parseAltTags(alt) {
    var tags = {};
    if (!alt) return tags;

    var normalized = alt.replace(/\s\|\s/g, '#').replace(/\|/g, '#');
    normalized.split('#').forEach(function (part) {
      part = part.trim();
      var splitAt = part.indexOf('_');
      if (splitAt <= 0) return;

      var key = part.slice(0, splitAt).trim().toLowerCase();
      var value = part.slice(splitAt + 1).trim().toLowerCase();
      if (key && value) tags[key] = value;
    });

    return tags;
  }

  /* Shared/public images: keep in original media order (no DOM pin/reorder). */

  function getMediaAlt(cell) {
    if (!cell) return '';
    var dataAlt = cell.getAttribute('data-media-alt');
    if (dataAlt != null && dataAlt !== '') return dataAlt;
    var img = cell.querySelector('img');
    return img ? img.getAttribute('alt') || '' : '';
  }

  function parsePositionList(raw) {
    try {
      return JSON.parse(raw || '[]').map(Number).filter(function (n) {
        return !isNaN(n);
      });
    } catch (error) {
      return [];
    }
  }

  /** Keep Liquid's media.position list — never rewrite as DOM indexes after reorder. */
  function getHiddenMediaPositions(gallery) {
    var raw = gallery.getAttribute('data-kostch-media-positions');
    if (raw == null || raw === '') {
      raw = gallery.getAttribute('filtered-indexes') || '[]';
      gallery.setAttribute('data-kostch-media-positions', raw);
    }
    return parsePositionList(raw);
  }

  function setHiddenMediaPositions(gallery, positions) {
    var raw = JSON.stringify(positions || []);
    gallery.setAttribute('data-kostch-media-positions', raw);
    gallery.setAttribute('filtered-indexes', raw);
  }

  function applyHiddenByMediaPosition(gallery, hiddenPositions) {
    var hiddenMap = {};
    (hiddenPositions || []).forEach(function (pos) {
      hiddenMap[pos] = true;
    });

    gallery.querySelectorAll('.product-gallery__media[data-media-position]').forEach(function (cell) {
      var pos = parseInt(cell.getAttribute('data-media-position'), 10);
      var hide = !!hiddenMap[pos];
      cell.toggleAttribute('hidden', hide);

      var mediaId = cell.getAttribute('data-media-id');
      if (mediaId) {
        var thumb = gallery.querySelector('.product-gallery__thumbnail[data-media-id="' + mediaId + '"]');
        if (thumb) thumb.toggleAttribute('hidden', hide);
      }
    });

    syncDotsToCarousel(gallery);
  }

  function syncDotsToCarousel(gallery) {
    var carousel = gallery.querySelector('.product-gallery__carousel');
    var dots = gallery.querySelector('carousel-navigation.page-dots');
    if (!carousel || !dots) return;

    var cells = Array.from(carousel.querySelectorAll(':scope > .product-gallery__media'));
    Array.from(dots.querySelectorAll(':scope > button')).forEach(function (btn, index) {
      var cell = cells[index];
      if (cell) btn.toggleAttribute('hidden', cell.hasAttribute('hidden'));
    });
  }

  function isSharedMediaAlt(alt) {
    if (!alt) return true;
    if (alt.indexOf('#') === -1) return true;
    return /#(shared|common|all)(\b|$)|#order:/i.test(alt);
  }

  function shouldHideMediaCell(cell, colors) {
    if (!cell) return false;
    if (cell.getAttribute('data-gallery-shared') === 'true') return false;

    var alt = getMediaAlt(cell);
    if (isSharedMediaAlt(alt)) return false;

    var tags = parseAltTags(alt);
    var hasOptionTags =
      !!tags['base color'] ||
      !!tags['accent color'] ||
      !!tags.color ||
      !!tags.colour ||
      !!tags.finish;

    if (!hasOptionTags) return false;

    var selectedBase = colors.base ? colors.base.trim().toLowerCase() : '';
    var selectedAccent = colors.accent ? colors.accent.trim().toLowerCase() : '';

    if (tags['base color'] && selectedBase && tags['base color'] !== selectedBase) return true;
    if (tags.color && selectedBase && tags.color !== selectedBase) return true;
    if (tags.colour && selectedBase && tags.colour !== selectedBase) return true;
    if (tags.finish && selectedBase && tags.finish !== selectedBase) return true;
    if (tags['accent color'] && selectedAccent && tags['accent color'] !== selectedAccent) return true;

    return false;
  }

  /**
   * DO NOT reorder carousel DOM. Prestige filtered-indexes / carousel.filter /
   * thumb navigation all assume media.position order === DOM child order.
   * Reordering caused click-path galleries to diverge from refresh (Liquid) output.
   */
  function pinSharedGalleryMedia(gallery) {
    if (!gallery) return;
    var hiddenPositions = getHiddenMediaPositions(gallery);
    applyHiddenByMediaPosition(gallery, hiddenPositions);
    setHiddenMediaPositions(gallery, hiddenPositions);
  }

  function pinAllProductGalleries() {
    document.querySelectorAll('product-gallery[form]').forEach(pinSharedGalleryMedia);
  }

  /**
   * Copy Liquid's exact hidden / initial state from the product:rerender fragment.
   * This makes click behave like refresh.
   */
  function syncGalleryFromServerMarkup(gallery, nextGalleryMarkup) {
    if (!gallery || !nextGalleryMarkup) return null;

    var filtered = nextGalleryMarkup.getAttribute('filtered-indexes');
    if (filtered != null) {
      setHiddenMediaPositions(gallery, parsePositionList(filtered));
    }

    var targetMediaId = null;
    var initial =
      nextGalleryMarkup.querySelector('.product-gallery__media.is-initial:not([hidden])') ||
      nextGalleryMarkup.querySelector('.product-gallery__media.is-initial') ||
      nextGalleryMarkup.querySelector('.product-gallery__media:not([hidden])');
    if (initial) targetMediaId = initial.getAttribute('data-media-id');

    nextGalleryMarkup.querySelectorAll('.product-gallery__media[data-media-id]').forEach(function (src) {
      var id = src.getAttribute('data-media-id');
      var dest = gallery.querySelector('.product-gallery__media[data-media-id="' + id + '"]');
      if (!dest) return;
      dest.toggleAttribute('hidden', src.hasAttribute('hidden'));

      var thumb = gallery.querySelector('.product-gallery__thumbnail[data-media-id="' + id + '"]');
      if (thumb) thumb.toggleAttribute('hidden', src.hasAttribute('hidden'));
    });

    // Prestige may have just called carousel.filter(DOM indexes) — re-assert by media-id
    applyHiddenByMediaPosition(gallery, getHiddenMediaPositions(gallery));
    syncDotsToCarousel(gallery);

    return targetMediaId;
  }

  /** Prefer server filtered-indexes (media.position). Fallback: alt-tag color match. No DOM reorder. */
  function applyGalleryFilterFromServerOrColors(gallery, form, variant, serverFilteredAttr) {
    if (!gallery) return;

    if (serverFilteredAttr != null && serverFilteredAttr !== '') {
      var positions = parsePositionList(serverFilteredAttr);
      setHiddenMediaPositions(gallery, positions);
      applyHiddenByMediaPosition(gallery, positions);
    } else if (variant) {
      var colors = getColorsFromVariant(variant, form);
      var hiddenPositions = [];

      gallery.querySelectorAll('.product-gallery__media[data-media-position]').forEach(function (cell) {
        if (shouldHideMediaCell(cell, colors)) {
          hiddenPositions.push(parseInt(cell.getAttribute('data-media-position'), 10));
        }
      });

      setHiddenMediaPositions(gallery, hiddenPositions);
      applyHiddenByMediaPosition(gallery, hiddenPositions);
    }

    syncDotsToCarousel(gallery);
  }

  function getColorsFromVariant(variant, form) {
    var result = { base: null, accent: null };
    if (!variant || !form) return result;

    var picker = document.querySelector('variant-picker[form-id="' + form.id + '"]');
    if (!picker) return result;

    picker.querySelectorAll('fieldset').forEach(function (fieldset) {
      var legend = fieldset.querySelector('legend');
      if (!legend) return;

      var name = legend.textContent.replace(':', '').trim().toLowerCase();
      var input = fieldset.querySelector('input[data-option-position]');
      if (!input) return;

      var position = parseInt(input.getAttribute('data-option-position'), 10);
      var value = variant['option' + position];
      if (!value) return;

      if (name === 'base color' || name === 'color' || name === 'colour' || name === 'finish') {
        result.base = value;
      }
      if (name === 'accent color') result.accent = value;
    });

    return result;
  }

  function matchesColorTags(alt, colors) {
    var tags = parseAltTags(alt);
    if (!tags['base color'] && !tags.color && !tags.colour && !tags.finish) return false;

    var selectedBase = colors.base ? colors.base.trim().toLowerCase() : '';
    var selectedAccent = colors.accent ? colors.accent.trim().toLowerCase() : '';
    var tagBase = tags['base color'] || tags.color || tags.colour || tags.finish;

    if (selectedBase && tagBase && tagBase !== selectedBase) return false;
    if (colors.accent && tags['accent color'] && tags['accent color'] !== selectedAccent) {
      return false;
    }
    return true;
  }

  function getColorGroupCells(carousel, colors) {
    return Array.from(carousel.querySelectorAll('.product-gallery__media')).filter(function (cell) {
      if (cell.hasAttribute('hidden')) return false;
      return matchesColorTags(getMediaAlt(cell), colors);
    });
  }

  function getVisibleCells(carousel) {
    return Array.from(carousel.querySelectorAll('.product-gallery__media')).filter(function (cell) {
      return !cell.hasAttribute('hidden');
    });
  }

  /**
   * Prestige scroll-carousel.select() no-ops when selectedIndex already equals the
   * target index — even if filter left scrollLeft on a different (wrong) slide.
   */
  function selectGalleryCell(carousel, cell) {
    if (!cell || !carousel) return;
    if (cell.hasAttribute('hidden')) return;

    var visibleCells = getVisibleCells(carousel);
    var index = visibleCells.indexOf(cell);
    if (index < 0) return;

    var needsBounce =
      typeof carousel.select === 'function' &&
      carousel.selectedIndex === index &&
      visibleCells.length > 1;

    if (needsBounce) {
      var other = index === 0 ? 1 : 0;
      carousel.select(other, { instant: true });
    }

    if (typeof carousel.select === 'function') {
      carousel.select(index, { instant: true });
    }

    try {
      var left = cell.offsetLeft;
      var align = getComputedStyle(cell).scrollSnapAlign || 'center';
      if (align === 'center') {
        left = cell.offsetLeft - (carousel.clientWidth - cell.clientWidth) / 2;
      } else if (align === 'end') {
        left = cell.offsetLeft - (carousel.clientWidth - cell.clientWidth);
      }
      left = Math.max(0, left);
      carousel.scrollTo({ left: left, behavior: 'auto' });
    } catch (e) {}

    var gallery = carousel.closest('product-gallery');
    var mediaId = cell.getAttribute('data-media-id');
    if (gallery && mediaId) {
      gallery.querySelectorAll('.product-gallery__thumbnail').forEach(function (btn) {
        btn.setAttribute('aria-current', btn.getAttribute('data-media-id') === mediaId ? 'true' : 'false');
      });
    }
  }

  function selectGalleryMediaById(gallery, mediaId) {
    if (!gallery || !mediaId) return false;
    var carousel = gallery.querySelector('.product-gallery__carousel');
    if (!carousel) return false;
    var cell = carousel.querySelector(
      '.product-gallery__media[data-media-id="' + mediaId + '"]:not([hidden])'
    );
    if (!cell) return false;
    selectGalleryCell(carousel, cell);
    return true;
  }

  var galleryViewState = new WeakMap();

  function getCurrentVariant(form) {
    var picker = document.querySelector('variant-picker[form-id="' + form.id + '"]');
    var variantScript = picker && picker.querySelector('script[data-variant]');
    if (!variantScript) return null;

    try {
      return JSON.parse(variantScript.textContent || '{}');
    } catch (error) {
      return null;
    }
  }

  function rememberGalleryView(gallery) {
    var carousel = gallery.querySelector('.product-gallery__carousel');
    if (!carousel) return;

    var form = document.forms[gallery.getAttribute('form')];
    if (!form) return;

    var selectedCell = carousel.selectedCell;
    if (!selectedCell) return;

    var colors = getColorsFromVariant(getCurrentVariant(form), form);
    var tags = parseAltTags(getMediaAlt(selectedCell));

    if (tags['base color'] || tags.color || tags.colour || tags.finish) {
      var group = getColorGroupCells(carousel, colors);
      galleryViewState.set(gallery, {
        viewIndex: group.indexOf(selectedCell),
        hasColorView: group.indexOf(selectedCell) >= 0,
        mediaId: selectedCell.getAttribute('data-media-id')
      });
    } else {
      galleryViewState.set(gallery, {
        hasColorView: false,
        mediaId: selectedCell.getAttribute('data-media-id')
      });
    }
  }

  function scrollProductGalleryToSelection(form, variant, previousVariant, preferredMediaId) {
    if (!form || form.tagName !== 'FORM') return;

    var gallery = document.querySelector('product-gallery[form="' + form.id + '"]');
    if (!gallery) return;

    var carousel = gallery.querySelector('.product-gallery__carousel');
    if (!carousel) return;

    if (preferredMediaId && selectGalleryMediaById(gallery, preferredMediaId)) {
      return;
    }

    var oldColors = getColorsFromVariant(previousVariant, form);
    var newColors = getColorsFromVariant(variant, form);
    var baseColorChanged =
      !oldColors.base ||
      !newColors.base ||
      oldColors.base.trim().toLowerCase() !== newColors.base.trim().toLowerCase();

    var target = null;
    var state = galleryViewState.get(gallery) || {};
    var colorGroup = newColors.base ? getColorGroupCells(carousel, newColors) : [];

    if (baseColorChanged && colorGroup.length) {
      target = colorGroup[0];
    }

    if (!target && colorGroup.length && state.hasColorView && state.viewIndex >= 0) {
      target = colorGroup[state.viewIndex] || colorGroup[0];
    }

    if (!target && state.mediaId) {
      target = gallery.querySelector(
        '.product-gallery__media[data-media-id="' + state.mediaId + '"]:not([hidden])'
      );
    }

    if (!target && variant && variant.featured_media && variant.featured_media.id) {
      var featured = gallery.querySelector(
        '.product-gallery__media[data-media-id="' + variant.featured_media.id + '"]:not([hidden])'
      );
      if (
        featured &&
        (!newColors.base ||
          matchesColorTags(getMediaAlt(featured), newColors) ||
          isSharedMediaAlt(getMediaAlt(featured)))
      ) {
        if (baseColorChanged && isSharedMediaAlt(getMediaAlt(featured)) && colorGroup.length) {
          target = colorGroup[0];
        } else {
          target = featured;
        }
      }
    }

    if (!target && colorGroup.length) target = colorGroup[0];
    if (!target) target = gallery.querySelector('.product-gallery__media:not([hidden])');

    if (target) selectGalleryCell(carousel, target);
  }

  function scheduleGalleryScroll(form, variant, previousVariant, preferredMediaId) {
    var run = function () {
      scrollProductGalleryToSelection(form, variant, previousVariant, preferredMediaId);
    };
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        run();
        window.setTimeout(run, 40);
        window.setTimeout(run, 160);
      });
    });
  }

  function initProductGalleryVariantScroll() {
    document.querySelectorAll('product-gallery[form]').forEach(function (gallery) {
      var carousel = gallery.querySelector('.product-gallery__carousel');
      if (!carousel) return;

      getHiddenMediaPositions(gallery);
      pinSharedGalleryMedia(gallery);

      carousel.addEventListener('carousel:settle', function () {
        rememberGalleryView(gallery);
      });

      gallery.addEventListener(
        'click',
        function (event) {
          var thumb = event.target.closest('.product-gallery__thumbnail');
          if (!thumb || !gallery.contains(thumb)) return;

          var mediaId = thumb.getAttribute('data-media-id');
          if (!mediaId) return;

          var cell = carousel.querySelector(
            '.product-gallery__media[data-media-id="' + mediaId + '"]'
          );
          if (!cell || cell.hasAttribute('hidden')) return;

          event.preventDefault();
          event.stopImmediatePropagation();
          selectGalleryCell(carousel, cell);

          window.requestAnimationFrame(function () {
            rememberGalleryView(gallery);
          });
        },
        true
      );
    });

    document.addEventListener('product:rerender', function (event) {
      var form = event.target;
      if (!form || form.tagName !== 'FORM') return;

      var gallery = document.querySelector('product-gallery[form="' + form.id + '"]');
      if (!gallery) return;

      var previousVariant = galleryViewState.get(gallery) && galleryViewState.get(gallery).lastVariant;
      var variant = getCurrentVariant(form);
      var fragment = event.detail && event.detail.htmlFragment;
      var preferredMediaId = null;
      var serverFiltered = null;

      if (fragment) {
        var nextGallery =
          fragment.querySelector('product-gallery[form="' + form.id + '"]') ||
          fragment.querySelector('product-gallery');
        if (nextGallery) {
          serverFiltered = nextGallery.getAttribute('filtered-indexes');
          // Run after Prestige onSectionRerender's carousel.filter(DOM indexes)
          window.setTimeout(function () {
            preferredMediaId = syncGalleryFromServerMarkup(gallery, nextGallery);
            gallery.setAttribute('data-kostch-filter-fresh', '1');
            scheduleGalleryScroll(form, variant, previousVariant, preferredMediaId);
          }, 0);
        }
      }

      if (!fragment || !serverFiltered) {
        applyGalleryFilterFromServerOrColors(gallery, form, variant, serverFiltered);
        gallery.setAttribute('data-kostch-filter-fresh', '1');
        scheduleGalleryScroll(form, variant, previousVariant, preferredMediaId);
      }

      var state = galleryViewState.get(gallery) || {};
      state.lastVariant = variant;
      galleryViewState.set(gallery, state);
    });

    document.addEventListener('variant:change', function (event) {
      var detail = event.detail || {};
      var form = event.target;
      if (!form || form.tagName !== 'FORM') return;

      var gallery = document.querySelector('product-gallery[form="' + form.id + '"]');
      if (!gallery) return;

      window.setTimeout(function () {
        if (gallery.getAttribute('data-kostch-filter-fresh') !== '1') {
          applyGalleryFilterFromServerOrColors(gallery, form, detail.variant, null);
        }
        gallery.removeAttribute('data-kostch-filter-fresh');
        // Re-apply media.position hide after Prestige may have used DOM indexes
        applyHiddenByMediaPosition(gallery, getHiddenMediaPositions(gallery));
        scheduleGalleryScroll(form, detail.variant, detail.previousVariant, null);
      }, 0);

      var state = galleryViewState.get(gallery) || {};
      state.lastVariant = detail.variant;
      galleryViewState.set(gallery, state);
    });
  }

  function initBackToTop() {
    var btn = document.querySelector('[data-kostch-back-top]');
    if (!btn) return;

    var threshold = 240;
    var ticking = false;

    function scrollY() {
      return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    }

    function syncVisibility() {
      ticking = false;
      var show = scrollY() > threshold;
      btn.classList.toggle('is-visible', show);
      btn.setAttribute('aria-hidden', show ? 'false' : 'true');
      btn.tabIndex = show ? 0 : -1;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(syncVisibility);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });

    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      try {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      } catch (e) {}
    });

    syncVisibility();
  }

  /**
   * Homepage hero = exact first screen (innerHeight − header chrome).
   * CSS dvh fallback alone still overshoots slightly on some Windows/DPI setups.
   */
  function syncHomepageHeroHeight() {
    if (!document.body || !document.body.classList.contains('kostch-page')) return;
    var hero =
      document.querySelector('#main > .shopify-section--slideshow:first-child') ||
      document.querySelector('#main > .shopify-section--slideshow');
    if (!hero) return;

    var header = document.querySelector('.shopify-section--header');
    var announcement = document.querySelector('.shopify-section--announcement-bar');
    var chrome =
      (header ? header.offsetHeight : 0) +
      (announcement ? announcement.offsetHeight : 0);
    var h = Math.max(280, Math.round(window.innerHeight - chrome));
    hero.style.setProperty('--kostch-hero-height', h + 'px');
  }

  // Back-to-top first so gallery errors cannot block it
  try {
    initBackToTop();
  } catch (e) {}

  function initGalleryThumbArrows() {
    function syncThumbArrows(wrap) {
      var scroller = wrap.querySelector('[data-kostch-thumb-scroller]');
      var prev = wrap.querySelector('[data-kostch-thumb-prev]');
      var next = wrap.querySelector('[data-kostch-thumb-next]');
      if (!scroller || !prev || !next) return;

      var maxScroll = Math.max(0, scroller.scrollWidth - scroller.clientWidth - 1);
      var canScroll = maxScroll > 2;
      wrap.classList.toggle('is-static', !canScroll);

      if (!canScroll) {
        prev.disabled = true;
        next.disabled = true;
        return;
      }

      prev.disabled = scroller.scrollLeft <= 2;
      next.disabled = scroller.scrollLeft >= maxScroll;
    }

    function step(scroller, dir) {
      var thumb = scroller.querySelector('.product-gallery__thumbnail:not([hidden])');
      var amount = thumb ? thumb.getBoundingClientRect().width + 8 : 141;
      scroller.scrollBy({ left: dir * amount * 2, behavior: 'smooth' });
    }

    document.querySelectorAll('[data-kostch-gallery-thumbs]').forEach(function (wrap) {
      if (wrap.getAttribute('data-kostch-thumbs-ready') === '1') {
        syncThumbArrows(wrap);
        return;
      }
      wrap.setAttribute('data-kostch-thumbs-ready', '1');

      var scroller = wrap.querySelector('[data-kostch-thumb-scroller]');
      var prev = wrap.querySelector('[data-kostch-thumb-prev]');
      var next = wrap.querySelector('[data-kostch-thumb-next]');
      if (!scroller || !prev || !next) return;

      prev.addEventListener('click', function () {
        step(scroller, -1);
      });
      next.addEventListener('click', function () {
        step(scroller, 1);
      });
      scroller.addEventListener('scroll', function () {
        syncThumbArrows(wrap);
      }, { passive: true });

      if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(function () {
          syncThumbArrows(wrap);
        }).observe(scroller);
      }

      syncThumbArrows(wrap);
    });
  }

  try {
    initGalleryThumbArrows();
    document.addEventListener('shopify:section:load', initGalleryThumbArrows);
    document.addEventListener('product:rerender', function () {
      requestAnimationFrame(initGalleryThumbArrows);
    });
  } catch (e) {}

  document.addEventListener('click', function (event) {
    var back = event.target.closest('[data-kostch-history-back]');
    if (!back) return;
    if (window.history.length > 1) {
      event.preventDefault();
      window.history.back();
    }
  });

  try {
    syncHomepageHeroHeight();
    window.addEventListener('resize', syncHomepageHeroHeight);
    window.addEventListener('orientationchange', syncHomepageHeroHeight);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(syncHomepageHeroHeight).catch(function () {});
    }
    requestAnimationFrame(syncHomepageHeroHeight);
  } catch (e) {}

  document.querySelectorAll('[data-kostch-carousel]').forEach(initProductCarousel);
  document.querySelectorAll('[data-kostch-media-carousel]').forEach(initMediaCarousel);
  function bootSceneShops(scope) {
    (scope || document).querySelectorAll('[data-kostch-scene-shop]').forEach(function (root) {
      if (root.getAttribute('data-kostch-scene-ready') === '1') return;
      root.setAttribute('data-kostch-scene-ready', '1');
      initSceneShop(root);
    });
  }
  bootSceneShops(document);
  document.addEventListener('shopify:section:load', function (event) {
    bootSceneShops(event.target);
  });

  // Prestige-style stagger reveal (blog cards)
  document.querySelectorAll('[data-kostch-reveal]').forEach(function (grid) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      grid.classList.add('is-revealed');
      return;
    }
    if (!('IntersectionObserver' in window)) {
      grid.classList.add('is-revealed');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '-50px 0px' });
    io.observe(grid);
  });

  try {
    initProductGalleryVariantScroll();
    pinAllProductGalleries();
  } catch (e) {}

  function initProductDescToggle() {
    document.querySelectorAll('[data-kostch-product-desc]').forEach(function (wrap) {
      var body = wrap.querySelector('[data-kostch-desc-body]');
      var toggle = wrap.querySelector('[data-kostch-desc-toggle]');
      var moreLabel = wrap.querySelector('[data-kostch-desc-more]');
      var lessLabel = wrap.querySelector('[data-kostch-desc-less]');
      if (!body || !toggle) return;

      function measure() {
        var wasExpanded = wrap.classList.contains('is-expanded');
        wrap.classList.remove('is-expanded');
        var overflowing = body.scrollHeight > body.clientHeight + 2;
        if (wasExpanded) wrap.classList.add('is-expanded');

        if (!overflowing && !wasExpanded) {
          toggle.hidden = true;
          return;
        }

        toggle.hidden = false;
        if (moreLabel) moreLabel.hidden = wasExpanded;
        if (lessLabel) lessLabel.hidden = !wasExpanded;
        toggle.setAttribute('aria-expanded', wasExpanded ? 'true' : 'false');
      }

      if (wrap.getAttribute('data-kostch-desc-ready') !== '1') {
        wrap.setAttribute('data-kostch-desc-ready', '1');
        toggle.addEventListener('click', function () {
          var open = wrap.classList.toggle('is-expanded');
          if (moreLabel) moreLabel.hidden = open;
          if (lessLabel) lessLabel.hidden = !open;
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      }

      measure();
    });
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-kostch-write-review], [data-kostch-ask-question]');
    if (!link) return;
    event.preventDefault();

    var ask = link.hasAttribute('data-kostch-ask-question');
    var target = document.querySelector(
      ask
        ? '.jdgm-qna-widget, .jdgm-qa-widget, .jdgm-widget.jdgm-qna, #judgeme_product_reviews, .jdgm-review-widget, .jdgm-rev-widg'
        : '#judgeme_product_reviews, .jdgm-review-widget, .jdgm-rev-widg'
    );
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });

    window.setTimeout(function () {
      if (ask) {
        var tabs = document.querySelectorAll('button, a, [role="tab"]');
        for (var t = 0; t < tabs.length; t++) {
          if (tabs[t].hasAttribute('data-kostch-ask-question') || tabs[t].hasAttribute('data-kostch-write-review')) continue;
          var tabText = (tabs[t].textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
          if (tabText === 'questions' || tabText === 'questions & answers' || tabText.indexOf('questions') === 0) {
            tabs[t].click();
            break;
          }
        }
      }
      var button = ask
        ? document.querySelector('.jdgm-ask-question-btn, .jdgm-write-rev-link.jdgm-ask-question, a.jdgm-ask-question')
        : document.querySelector('.jdgm-write-rev-link:not(.jdgm-ask-question), .jdgm-write-review-button');
      if (!button) {
        var wanted = ask ? 'ask a question' : 'write a review';
        var nodes = document.querySelectorAll('a, button');
        for (var i = 0; i < nodes.length; i++) {
          if (nodes[i].hasAttribute('data-kostch-write-review') || nodes[i].hasAttribute('data-kostch-ask-question')) continue;
          var text = (nodes[i].textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
          if (text === wanted || text.indexOf(wanted) === 0) {
            button = nodes[i];
            break;
          }
        }
      }
      if (button) button.click();
    }, 450);
  });

  try {
    initProductDescToggle();
    window.addEventListener('resize', function () {
      initProductDescToggle();
    });
    document.addEventListener('shopify:section:load', initProductDescToggle);
    document.addEventListener('product:rerender', function () {
      requestAnimationFrame(initProductDescToggle);
    });
  } catch (e) {}

  function initSupportForms() {
    document.querySelectorAll('.kostch-support-form--sheet').forEach(function (formRoot) {
      if (formRoot.getAttribute('data-kostch-form-ready') === '1') return;
      formRoot.setAttribute('data-kostch-form-ready', '1');

      var form = formRoot.querySelector('form');
      var proof = formRoot.querySelector('[data-kostch-proof]');
      var media = formRoot.querySelector('[data-kostch-media]');
      var totalMaxBytes = 30 * 1024 * 1024;
      var mediaFiles = [];
      var mediaBusy = false;

      function mediaKind(file) {
        var name = file.name || '';
        if (file.type.indexOf('video/') === 0 || /\.(mp4|mov|m4v|webm)$/i.test(name)) return 'video';
        if (file.type.indexOf('image/') === 0 || /\.(jpe?g|png|webp|gif|heic)$/i.test(name)) return 'image';
        return '';
      }

      function usedAttachmentBytes() {
        var proofInput = proof && proof.querySelector('[data-kostch-proof-input]');
        var proofFile = proofInput && proofInput.files && proofInput.files[0];
        var total = proofFile ? proofFile.size : 0;
        mediaFiles.forEach(function (file) { total += file.size; });
        return total;
      }

      function fillSupportName() {
        var first = formRoot.querySelector('[data-kostch-first-name]');
        var last = formRoot.querySelector('[data-kostch-last-name]');
        var full = formRoot.querySelector('[data-kostch-full-name]');
        if (full && first && last) full.value = (first.value + ' ' + last.value).replace(/\s+/g, ' ').trim();
      }

      function showSupportBanner(ok, text) {
        if (!form) return;
        var old = form.querySelector('.kostch-support-form__banner');
        if (old) old.remove();
        var el = document.createElement('div');
        el.className = 'kostch-support-form__banner ' + (ok ? 'is-success' : 'is-error');
        el.setAttribute('role', ok ? 'status' : 'alert');
        el.textContent = text;
        form.insertBefore(el, form.firstChild);
        if (el.scrollIntoView) el.scrollIntoView({ block: 'nearest' });
      }

      if (form) {
        form.addEventListener('submit', function (event) {
          fillSupportName();
          if (mediaBusy) {
            event.preventDefault();
            showSupportBanner(false, 'Please wait until the video finishes compressing.');
            return;
          }
          var ticketUrl = formRoot.getAttribute('data-kostch-upload-ticket');
          if (!ticketUrl || !window.fetch || !window.FormData) return;

          event.preventDefault();
          var button = form.querySelector('[type="submit"]');
          var proofInput = proof && proof.querySelector('[data-kostch-proof-input]');
          var proofFile = proofInput && proofInput.files && proofInput.files[0];
          var hasFiles = !!proofFile || mediaFiles.length > 0;
          if (button) {
            button.disabled = true;
            button.setAttribute('aria-busy', 'true');
          }

          function releaseButton() {
            if (!button) return;
            button.disabled = false;
            button.removeAttribute('aria-busy');
          }

          fetch(ticketUrl, {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            credentials: 'same-origin',
            body: '{}'
          }).then(function (res) {
            if (!res.ok) throw new Error('ticket');
            return res.json();
          }).then(function (ticket) {
            if (!ticket || !ticket.token || !ticket.uploadUrl) throw new Error('ticket');
            var data = new FormData(form);
            data.append('token', ticket.token);
            if (proofFile) data.append('proof', proofFile);
            mediaFiles.forEach(function (file) { data.append('media', file); });
            return fetch(ticket.uploadUrl, { method: 'POST', body: data, credentials: 'omit' });
          }).then(function (res) {
            return res.json().then(function (body) {
              if (!res.ok || !body || !body.ok) throw new Error((body && body.error) || 'upload');
            });
          }).then(function () {
            mediaFiles.splice(0, mediaFiles.length);
            var slots = formRoot.querySelector('[data-kostch-media-slots]');
            if (slots) slots.innerHTML = '';
            var mediaTitle = formRoot.querySelector('[data-kostch-media-title]');
            var mediaHint = formRoot.querySelector('[data-kostch-media-hint]');
            var mediaDrop = media && media.querySelector('.kostch-support-form__drop');
            var mediaNames = formRoot.querySelector('[data-kostch-media-names]');
            if (mediaTitle) mediaTitle.textContent = 'Upload photos or videos';
            if (mediaHint) mediaHint.textContent = 'All attachments together: 30 MB. Extra video is trimmed.';
            if (mediaDrop) mediaDrop.classList.remove('is-filled');
            if (mediaNames) mediaNames.value = '';
            var proofTitle = proof && proof.querySelector('[data-kostch-proof-title]');
            var proofHint = proof && proof.querySelector('[data-kostch-proof-hint]');
            var proofDrop = proof && proof.querySelector('.kostch-support-form__drop');
            var proofName = proof && proof.querySelector('[data-kostch-proof-name]');
            if (proofTitle) proofTitle.textContent = 'Upload PDF or JPG';
            if (proofHint) proofHint.textContent = 'PDF or JPG. All attachments together: 30 MB.';
            if (proofDrop) proofDrop.classList.remove('is-filled');
            if (proofName) proofName.value = '';
            form.reset();
            showSupportBanner(true, formRoot.getAttribute('data-kostch-success') || 'Thank you. We have received your request and will respond soon.');
            releaseButton();
          }).catch(function () {
            releaseButton();
            if (!hasFiles) {
              form.submit();
              return;
            }
            showSupportBanner(false, 'We could not upload your files. Please try again. If this continues, email the files to service@kostch.com.');
          });
        });
      }

      if (proof) {
        var proofInput = proof.querySelector('[data-kostch-proof-input]');
        var proofTitle = proof.querySelector('[data-kostch-proof-title]');
        var proofHint = proof.querySelector('[data-kostch-proof-hint]');
        var proofError = proof.querySelector('[data-kostch-proof-error]');
        var proofName = proof.querySelector('[data-kostch-proof-name]');
        var proofDrop = proof.querySelector('.kostch-support-form__drop');

        proofInput.addEventListener('change', function () {
          var file = proofInput.files && proofInput.files[0];
          proofError.hidden = true;
          if (!file) return;
          var okType = file.type === 'application/pdf' || file.type === 'image/jpeg' || /\.(pdf|jpe?g)$/i.test(file.name);
          var proofOthers = usedAttachmentBytes() - file.size;
          if (!okType || file.size > totalMaxBytes - proofOthers) {
            proofInput.value = '';
            proofName.value = '';
            proofDrop.classList.remove('is-filled');
            proofTitle.textContent = 'Upload PDF or JPG';
            proofHint.textContent = 'PDF or JPG. All attachments together: 30 MB.';
            proofError.hidden = false;
            proofError.textContent = okType ? 'All attachments together must be 30 MB or smaller.' : 'Please choose a PDF or JPG file.';
            return;
          }
          proofDrop.classList.add('is-filled');
          proofTitle.textContent = file.name;
          proofHint.textContent = 'Click to replace';
          proofName.value = file.name;
        });
      }

      if (media) {
        var mediaFiles = [];
        var mediaSlots = media.querySelector('[data-kostch-media-slots]');
        var mediaInput = media.querySelector('[data-kostch-media-input]');
        var mediaError = media.querySelector('[data-kostch-media-error]');
        var mediaNames = media.querySelector('[data-kostch-media-names]');
        var mediaTitle = media.querySelector('[data-kostch-media-title]');
        var mediaHint = media.querySelector('[data-kostch-media-hint]');
        var mediaDrop = media.querySelector('.kostch-support-form__drop');

        function renderMedia() {
          mediaSlots.innerHTML = '';
          mediaFiles.forEach(function (file, index) {
            var slot = document.createElement('div');
            slot.className = 'kostch-support-form__slot';
            if (mediaKind(file) === 'video') {
              var video = document.createElement('video');
              video.muted = true;
              video.src = URL.createObjectURL(file);
              slot.appendChild(video);
            } else {
              var img = document.createElement('img');
              img.alt = '';
              img.src = URL.createObjectURL(file);
              slot.appendChild(img);
            }
            var remove = document.createElement('button');
            remove.type = 'button';
            remove.className = 'kostch-support-form__slot-remove';
            remove.setAttribute('aria-label', 'Remove file');
            remove.textContent = '×';
            remove.addEventListener('click', function (event) {
              event.preventDefault();
              event.stopPropagation();
              mediaFiles.splice(index, 1);
              renderMedia();
            });
            slot.appendChild(remove);
            mediaSlots.appendChild(slot);
          });

          if (mediaDrop) mediaDrop.classList.toggle('is-filled', mediaFiles.length > 0);
          if (mediaTitle) mediaTitle.textContent = mediaFiles.length ? mediaFiles.map(function (file) { return file.name; }).join(', ') : 'Upload photos or videos';
          if (mediaHint) mediaHint.textContent = mediaFiles.length ? 'Click to add another' : 'All attachments together: 30 MB. Extra video is trimmed.';
          mediaNames.value = mediaFiles.map(function (file) { return file.name; }).join(', ');
        }

        function showMediaNotice(text) {
          mediaError.hidden = false;
          mediaError.classList.add('is-notice');
          mediaError.textContent = text;
        }

        function showMediaError(text) {
          mediaError.hidden = false;
          mediaError.classList.remove('is-notice');
          mediaError.textContent = text;
        }

        function evenSize(value) {
          var rounded = Math.max(2, Math.round(value));
          return rounded % 2 === 0 ? rounded : rounded - 1;
        }

        function compressVideo(file, limitBytes) {
          return new Promise(function (resolve, reject) {
            if (file.size <= limitBytes) {
              resolve({ file: file, trimmed: false });
              return;
            }
            var canvasProbe = document.createElement('canvas');
            if (!window.MediaRecorder || !canvasProbe.captureStream) {
              reject(new Error('compress'));
              return;
            }
            var mime = '';
            if (MediaRecorder.isTypeSupported('video/webm;codecs=vp8')) mime = 'video/webm;codecs=vp8';
            else if (MediaRecorder.isTypeSupported('video/webm')) mime = 'video/webm';
            else if (MediaRecorder.isTypeSupported('video/mp4')) mime = 'video/mp4';
            if (!mime) {
              reject(new Error('compress'));
              return;
            }
            var url = URL.createObjectURL(file);
            var video = document.createElement('video');
            var settled = false;
            var trimmed = false;
            var chunks = [];
            var recordedBytes = 0;
            video.muted = true;
            video.playsInline = true;
            video.preload = 'auto';
            video.src = url;

            function finish(err, out) {
              if (settled) return;
              settled = true;
              URL.revokeObjectURL(url);
              video.pause();
              video.removeAttribute('src');
              try { video.load(); } catch (loadErr) {}
              if (err) reject(err);
              else resolve(out);
            }

            function stopRecorder(recorder, frame) {
              trimmed = true;
              cancelAnimationFrame(frame);
              video.pause();
              if (recorder.state !== 'inactive') recorder.stop();
            }

            video.onerror = function () { finish(new Error('compress')); };
            video.onloadedmetadata = function () {
              var maxSeconds = Math.max(8, Math.floor((limitBytes * 8) / 900000) - 2);
              var scale = Math.min(1, 1280 / (video.videoWidth || 1280), 720 / (video.videoHeight || 720));
              var canvas = document.createElement('canvas');
              canvas.width = evenSize((video.videoWidth || 1280) * scale);
              canvas.height = evenSize((video.videoHeight || 720) * scale);
              var ctx = canvas.getContext('2d');
              var recorder;
              try {
                recorder = new MediaRecorder(canvas.captureStream(24), {
                  mimeType: mime,
                  videoBitsPerSecond: 900000
                });
              } catch (err) {
                finish(new Error('compress'));
                return;
              }
              var frame = 0;
              recorder.ondataavailable = function (event) {
                if (!event.data || !event.data.size) return;
                if (recordedBytes + event.data.size > limitBytes) {
                  if (!trimmed) stopRecorder(recorder, frame);
                  return;
                }
                chunks.push(event.data);
                recordedBytes += event.data.size;
                if (!trimmed && recordedBytes >= limitBytes - 160000) stopRecorder(recorder, frame);
              };
              recorder.onerror = function () { finish(new Error('compress')); };
              recorder.onstop = function () {
                var type = mime.indexOf('mp4') !== -1 ? 'video/mp4' : 'video/webm';
                var ext = type === 'video/mp4' ? '.mp4' : '.webm';
                var base = String(file.name || 'video').replace(/\.[^.]+$/, '');
                var compressed = new File([new Blob(chunks, { type: type })], base + ext, { type: type });
                if (!compressed.size || compressed.size > limitBytes) {
                  finish(new Error('compress'));
                  return;
                }
                finish(null, { file: compressed, trimmed: trimmed });
              };
              function draw() {
                if (settled || trimmed || video.ended || video.paused) return;
                if (video.currentTime >= maxSeconds) {
                  stopRecorder(recorder, frame);
                  return;
                }
                ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                frame = requestAnimationFrame(draw);
              }
              video.onended = function () {
                cancelAnimationFrame(frame);
                if (recorder.state !== 'inactive') recorder.stop();
              };
              recorder.start(500);
              var playing = video.play();
              if (playing && playing.then) playing.then(draw).catch(function () { finish(new Error('compress')); });
              else draw();
            };
          });
        }

        function acceptMedia(file) {
          if (mediaFiles.length >= 5) {
            showMediaError('You can upload up to 5 files.');
            return Promise.resolve();
          }
          var kind = mediaKind(file);
          if (kind === 'image') {
            if (file.size > totalMaxBytes - usedAttachmentBytes()) {
              showMediaError('All attachments together must be 30 MB or smaller.');
              return Promise.resolve();
            }
            mediaFiles.push(file);
            renderMedia();
            return Promise.resolve();
          }
          if (kind !== 'video') {
            showMediaError('Please choose a photo or video.');
            return Promise.resolve();
          }
          var remaining = totalMaxBytes - usedAttachmentBytes();
          if (remaining < 200 * 1024) {
            showMediaNotice('Attachments are limited to 30 MB in total. The extra video was trimmed off.');
            return Promise.resolve();
          }
          mediaBusy = true;
          if (mediaTitle) mediaTitle.textContent = 'Compressing ' + file.name + '…';
          if (mediaHint) mediaHint.textContent = 'Extra footage over the 30 MB total will be trimmed automatically.';
          return compressVideo(file, remaining).then(function (result) {
            mediaFiles.push(result.file);
            if (result.trimmed) showMediaNotice('This video made the attachments larger than 30 MB, so the extra part was trimmed automatically.');
          }).catch(function () {
            showMediaError('Could not prepare this video. Please try a shorter clip.');
          }).then(function () {
            mediaBusy = false;
            var notice = !mediaError.hidden && mediaError.classList.contains('is-notice') ? mediaError.textContent : '';
            renderMedia();
            if (notice) showMediaNotice(notice);
          });
        }

        mediaInput.addEventListener('change', function () {
          var picked = Array.prototype.slice.call(mediaInput.files || []);
          mediaInput.value = '';
          mediaError.hidden = true;
          mediaError.classList.remove('is-notice');
          var queue = Promise.resolve();
          picked.forEach(function (file) {
            queue = queue.then(function () { return acceptMedia(file); });
          });
        });

        renderMedia();
      }
    });
  }

  try {
    initSupportForms();
    document.addEventListener('shopify:section:load', initSupportForms);
  } catch (e) {}

  function kostchText(el) {
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function kostchTagLeaves(root, pattern, className) {
    var nodes = root.querySelectorAll('h1, h2, h3, h4, p, span, div, button, a, label');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.querySelector('h1, h2, h3, p, button, a, img, svg')) continue;
      var text = kostchText(el);
      if (!text || text.length > 80) continue;
      if (pattern.test(text)) el.classList.add(className);
    }
  }

  function kostchFindByText(root, pattern, selector) {
    var nodes = root.querySelectorAll(selector || 'button, a, [role="button"], label, span, div, p');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.closest('.kostch-jm-trust, .kostch-jm-heading')) continue;
      var text = kostchText(el);
      if (!text || text.length > 100) continue;
      if (pattern.test(text)) return el;
    }
    return null;
  }

  function kostchClosestBlock(el) {
    if (!el) return null;
    return el.closest(
      '.jdgm-rev-widg__summary-average, .jdgm-histogram, .jdgm-widget-actions, .jdgm-gallery, .jdgm-gallery-wrapper, [class*="histogram"], [class*="Histogram"], [class*="average"], [class*="Average"], [class*="gallery"], [class*="Gallery"], [class*="media"], [class*="Media"], [class*="summary"], [class*="Summary"], [class*="actions"], [class*="Actions"]'
    ) || el.parentElement;
  }

  function kostchRecommendCopy(root) {
    var match = kostchText(root).match(/(\d+)\s*%\s*of customers recommend/i);
    if (match) return match[1] + '% of customers recommend this product.';
    return 'Customers recommend this product.';
  }

  function kostchBuildTrust(root) {
    var trust = document.createElement('div');
    trust.className = 'kostch-jm-trust';
    trust.innerHTML =
      '<div class="kostch-jm-trust__row">' +
        '<span class="kostch-jm-trust__icon" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24" width="28" height="28" fill="none"><path d="M12 3l7 3v5c0 5-3.2 8.4-7 10-3.8-1.6-7-5-7-10V6l7-3z" stroke="currentColor" stroke-width="1.6"/><path d="M9.2 12.1l1.9 1.9 3.8-3.9" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</span>' +
        '<p><strong>Verified Purchases</strong><span>All reviews are from verified purchases.</span></p>' +
      '</div>' +
      '<div class="kostch-jm-trust__row">' +
        '<span class="kostch-jm-trust__icon" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24" width="28" height="28" fill="none"><path d="M8 11v8H5.8A1.8 1.8 0 0 1 4 17.2V13a2 2 0 0 1 2-2h2zm0 0l3.2-5.2A1.8 1.8 0 0 1 12.8 5h.4A2.8 2.8 0 0 1 16 7.8V11h3.1a2 2 0 0 1 1.9 2.4l-1.2 6A2 2 0 0 1 17.9 21H8" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>' +
        '</span>' +
        '<p><strong class="kostch-jm-trust__recommend">' + kostchRecommendCopy(root) + '</strong></p>' +
      '</div>';
    return trust;
  }

  function kostchGatherJmParts(root) {
    var histogram =
      root.querySelector('.jdgm-histogram, [class*="histogram"], [class*="Histogram"]') ||
      null;
    var average =
      root.querySelector('.jdgm-rev-widg__summary-average, [class*="average-rating"], [class*="AverageRating"], [class*="summary-average"]') ||
      null;
    if (!average) {
      var scoreEl = root.querySelector('.kostch-jm-score');
      average = scoreEl ? kostchClosestBlock(scoreEl) : null;
    }
    var gallery =
      root.querySelector('.jdgm-gallery, .jdgm-gallery-wrapper, [class*="media-gallery"], [class*="MediaGallery"], [class*="review-media"], [class*="ReviewMedia"]') ||
      null;
    var writeBtn =
      root.querySelector('.kostch-jm-write, [data-testid="write-review-button"], .jdgm-write-rev-link, a.jdgm-write-rev-link') ||
      kostchFindByText(root, /^write a review$/i, 'button, a, [role="button"]');
    var askBtn =
      root.querySelector('.kostch-jm-ask, [data-testid="ask-question-button"], .jdgm-ask-question-btn, a.jdgm-ask-question') ||
      kostchFindByText(root, /^ask a question$/i, 'button, a, [role="button"]');
    var sort =
      root.querySelector('.jdgm-sort-dropdown, .jdgm-sort-dropdown-wrapper, select[name*="sort" i], [class*="sort"] select, [class*="Sort"] select') ||
      null;
    if (!sort) {
      var sortLabel = kostchFindByText(root, /^sort by/i, 'label, span, div, p');
      sort = sortLabel ? (sortLabel.closest('[class*="sort"], [class*="Sort"], label') || sortLabel.parentElement) : null;
    }
    var search =
      root.querySelector('input[type="search"], input[placeholder*="Search" i], [class*="search"] input') ||
      null;
    var actions =
      root.querySelector('.jdgm-widget-actions, [class*="widget-actions"], [class*="summary-actions"]') ||
      null;
    return {
      histogram: histogram,
      average: average,
      gallery: gallery,
      writeBtn: writeBtn,
      askBtn: askBtn,
      sort: sort,
      search: search,
      actions: actions
    };
  }

  function kostchBuildJmLayout(root) {
    if (root.querySelector('.kostch-jm-shell')) return true;
    var parts = kostchGatherJmParts(root);
    if (!parts.histogram && !parts.average) return false;

    var shell = document.createElement('div');
    shell.className = 'kostch-jm-shell';

    var summary = document.createElement('div');
    summary.className = 'kostch-jm-summary';

    var scoreCol = document.createElement('div');
    scoreCol.className = 'kostch-jm-summary__score';
    var histCol = document.createElement('div');
    histCol.className = 'kostch-jm-summary__histogram';
    var trustCol = document.createElement('div');
    trustCol.className = 'kostch-jm-summary__trust';

    if (parts.average) scoreCol.appendChild(parts.average);
    if (parts.histogram) histCol.appendChild(parts.histogram);
    trustCol.appendChild(kostchBuildTrust(root));

    summary.appendChild(scoreCol);
    summary.appendChild(histCol);
    summary.appendChild(trustCol);
    shell.appendChild(summary);

    if (parts.gallery) {
      var media = document.createElement('div');
      media.className = 'kostch-jm-media';
      media.appendChild(parts.gallery);
      shell.appendChild(media);
    }

    var toolbar = document.createElement('div');
    toolbar.className = 'kostch-jm-toolbar';
    var toolLeft = document.createElement('div');
    toolLeft.className = 'kostch-jm-toolbar__left';
    var toolCenter = document.createElement('div');
    toolCenter.className = 'kostch-jm-toolbar__center';
    var toolRight = document.createElement('div');
    toolRight.className = 'kostch-jm-toolbar__right';

    if (parts.sort) toolLeft.appendChild(parts.sort);
    if (parts.writeBtn) {
      var writeWrap = parts.writeBtn.closest('.jdgm-widget-actions, [class*="actions"]');
      if (writeWrap && writeWrap.contains(parts.writeBtn) && (!parts.askBtn || writeWrap.contains(parts.askBtn))) {
        /* keep button node only */
      }
      toolCenter.appendChild(parts.writeBtn);
    }
    if (parts.search) {
      var searchWrap = parts.search.closest('[class*="search"], [class*="Search"], form') || parts.search;
      toolRight.appendChild(searchWrap);
    }

    toolbar.appendChild(toolLeft);
    toolbar.appendChild(toolCenter);
    toolbar.appendChild(toolRight);
    shell.appendChild(toolbar);

    if (parts.askBtn) {
      parts.askBtn.classList.add('kostch-jm-ask');
      var askHost = parts.askBtn.closest('.jdgm-widget-actions, [class*="actions"]') || parts.askBtn;
      if (askHost && askHost !== parts.writeBtn) askHost.classList.add('kostch-jm-ask-slot');
      else parts.askBtn.classList.add('kostch-jm-ask-slot');
    }
    if (parts.actions) parts.actions.classList.add('kostch-jm-ask-slot');

    var insertBefore = root.querySelector('.jdgm-rev-widg__reviews, .jdgm-rev-widg__body, [class*="review-list"], [class*="ReviewList"], [class*="reviews-list"], .jdgm-subpanel, [role="tablist"]');
    if (insertBefore && insertBefore.parentElement === root) {
      root.insertBefore(shell, insertBefore);
    } else if (insertBefore) {
      insertBefore.parentElement.insertBefore(shell, insertBefore);
    } else {
      var heading = root.querySelector(':scope > .kostch-jm-heading');
      if (heading && heading.nextSibling) root.insertBefore(shell, heading.nextSibling);
      else root.appendChild(shell);
    }

    root.querySelectorAll('.jdgm-rev-widg__summary, [class*="summary-container"], [class*="SummaryContainer"]').forEach(function (el) {
      if (el.closest('.kostch-jm-shell')) return;
      if (!el.textContent || !String(el.textContent).replace(/\s+/g, '')) {
        el.style.display = 'none';
      }
    });

    return true;
  }

  function kostchEnhanceJmCards(root) {
    var cards = root.querySelectorAll('.jdgm-rev, .jm-review-item, [class*="jm-review-card"], [class*="ReviewCard"], [data-review-id]');
    cards.forEach(function (card) {
      if (card.closest('.kostch-jm-media, .kostch-jm-summary')) return;
      card.classList.add('kostch-jm-card');
      var author =
        card.querySelector('.jdgm-rev__author-wrapper, .jdgm-rev__header, [class*="author"], [class*="Author"], [class*="reviewer"]') ||
        null;
      var content =
        card.querySelector('.jdgm-rev__content, .jm-review-content, [class*="review-content"], [class*="ReviewContent"]') ||
        null;
      var pics =
        card.querySelector('.jdgm-rev__pics, [class*="review-media"], [class*="ReviewMedia"], [class*="rev__pics"]') ||
        null;
      if (author) author.classList.add('kostch-jm-card__author');
      if (content) content.classList.add('kostch-jm-card__content');
      if (pics) pics.classList.add('kostch-jm-card__media');
    });
  }

  function layoutJudgeMeSku() {
    var root = document.querySelector(
      '#judgeme_product_reviews, .jdgm-rev-widg, .jdgm-review-widget, .jdgm-widget.jdgm-review-widget'
    );
    if (!root) return;

    // Judge.me core scripts missing (App Embed off) — do not fake a blank REVIEWS block.
    var jmReady = typeof window.jdgm !== 'undefined' || typeof window.jdgmSettings !== 'undefined';
    var hasWidgetBody = !!(
      root.querySelector(
        '.jdgm-rev, .jm-review-item, .jdgm-rev-widg__summary, [class*="ReviewCard"], [data-review-id], .jdgm-histogram, [class*="average-rating"]'
      ) || root.querySelector('iframe')
    );
    if (!jmReady && !hasWidgetBody) {
      root.querySelectorAll(':scope > .kostch-jm-heading').forEach(function (el) {
        el.remove();
      });
      return;
    }

    root.classList.add('kostch-jm-root');

    // Only hide known Judge.me title nodes (never tag arbitrary "Reviews" text).
    var legacyTitle = root.querySelector(
      '.jdgm-rev-widg__title, .jm-header__title, .jm-widget-header__title, [class*="WidgetHeader"] [class*="title"], [data-testid="reviews-header"]'
    );
    if (legacyTitle && !legacyTitle.classList.contains('kostch-jm-heading')) {
      if (legacyTitle.getAttribute('data-kostch-title') !== '1') {
        legacyTitle.setAttribute('data-kostch-title', '1');
        legacyTitle.textContent = 'REVIEWS';
      }
      legacyTitle.classList.add('kostch-jm-title');
    }

    if (hasWidgetBody && !root.querySelector(':scope > .kostch-jm-heading')) {
      var heading = document.createElement('h2');
      heading.className = 'kostch-jm-heading';
      heading.textContent = 'REVIEWS';
      root.insertBefore(heading, root.firstChild);
    }

    // Recover from older destructive layout: unwrap shell, unhide hosts.
    var brokenShell = root.querySelector('.kostch-jm-shell');
    if (brokenShell) {
      while (brokenShell.firstChild) {
        brokenShell.parentNode.insertBefore(brokenShell.firstChild, brokenShell);
      }
      brokenShell.remove();
      root.removeAttribute('data-kostch-jm-layout');
    }
    root.querySelectorAll('[style*="display: none"], [style*="display:none"]').forEach(function (el) {
      if (!el.closest('#judgeme_product_reviews, .jdgm-rev-widg, .jdgm-review-widget')) return;
      if (el.classList.contains('kostch-jm-title')) return;
      var cls = String(el.className || '');
      if (/summary-container|SummaryContainer|jdgm-rev-widg__summary|widget-actions|ask-slot/i.test(cls)) {
        el.style.removeProperty('display');
      }
    });

    var scoreNodes = root.querySelectorAll('h1, h2, h3, h4, p, span, div');
    for (var s = 0; s < scoreNodes.length; s++) {
      var scoreNode = scoreNodes[s];
      if (scoreNode.querySelector('h1, h2, h3, p, button, a, img, svg')) continue;
      if (!/^\d+(\.\d+)?$/.test(kostchText(scoreNode))) continue;
      var n = parseFloat(kostchText(scoreNode));
      if (n < 0 || n > 5) continue;
      scoreNode.classList.add('kostch-jm-score');
      break;
    }

    kostchTagLeaves(root, /^write a review$/i, 'kostch-jm-write');
    kostchTagLeaves(root, /^ask a question$/i, 'kostch-jm-ask');
    kostchTagLeaves(root, /^yes\b/i, 'kostch-jm-yes');
    kostchTagLeaves(root, /^no\b/i, 'kostch-jm-no');
    kostchTagLeaves(root, /^recommended$/i, 'kostch-jm-recommended');
    kostchTagLeaves(root, /^view all photos/i, 'kostch-jm-view-all');

    root.querySelectorAll('[role="tab"], button, a').forEach(function (tab) {
      if (/^store reviews\b/i.test(kostchText(tab))) tab.classList.add('kostch-jm-store-tab');
    });

    // Do NOT rebuild/move Judge.me DOM. Aggressive shell layout broke the widget
    // (REVIEWS title only, empty body). Keep light class tagging + CSS only.

    // Undo damage from older layout runs if still present.
    root.querySelectorAll('.kostch-jm-ask-slot').forEach(function (el) {
      el.classList.remove('kostch-jm-ask-slot');
      el.style.removeProperty('display');
    });
    root.querySelectorAll('.jdgm-rev-widg__summary, [class*="summary-container"], [class*="SummaryContainer"]').forEach(function (el) {
      if (el.style && el.style.display === 'none' && !el.closest('.kostch-jm-shell')) {
        el.style.removeProperty('display');
      }
    });

    document.querySelectorAll('[role="dialog"], dialog').forEach(function (dialog) {
      var sample = kostchText(dialog).slice(0, 240);
      if (!/ask a question|write your review|overall rating|would you recommend/i.test(sample)) return;
      dialog.classList.add('kostch-jm-dialog');
      dialog.querySelectorAll('button, a').forEach(function (btn) {
        var label = kostchText(btn);
        if (/^submit$/i.test(label)) btn.classList.add('kostch-jm-submit');
        if (/^cancel$/i.test(label)) btn.classList.add('kostch-jm-cancel');
      });
    });
  }

  try {
    layoutJudgeMeSku();
    if (window.MutationObserver) {
      var judgePending = false;
      var judgeWatch = new MutationObserver(function (mutations) {
        if (judgePending) return;
        // Ignore our own heading / class-only tweaks to avoid feedback loops.
        var relevant = false;
        for (var m = 0; m < mutations.length; m++) {
          var nodes = mutations[m].addedNodes;
          for (var n = 0; n < nodes.length; n++) {
            var node = nodes[n];
            if (!node || node.nodeType !== 1) continue;
            if (node.classList && node.classList.contains('kostch-jm-heading')) continue;
            if (node.id === 'judgeme_product_reviews' || (node.querySelector && node.querySelector('#judgeme_product_reviews, .jdgm-rev-widg, .jdgm-review-widget'))) {
              relevant = true;
              break;
            }
            if (/jdgm|judgeme|jm-/i.test(node.className || node.id || '')) {
              relevant = true;
              break;
            }
          }
          if (relevant) break;
        }
        if (!relevant) return;
        judgePending = true;
        window.requestAnimationFrame(function () {
          judgePending = false;
          layoutJudgeMeSku();
        });
      });
      judgeWatch.observe(document.body, { childList: true, subtree: true });
    }
  } catch (e) {}
})();
